import React, { useEffect } from 'react'
import {
  Btn,
  CustomCalendar,
  CustomPanel,
  CustomTabView,
  ImportExcelFile,
} from '../../../../../components'
import { withRouter } from 'react-router-dom'
import { DataTable } from 'primereact/datatable'
import useImportacaoMultiploCicloEntregas from './ImportacaoMultiploCicloEntregaHook'
import { Column } from 'primereact/column'
import { TabPanel } from 'primereact/tabview'
import { tableCellCentered } from '../../../../../assets/js/styles'
import { connect } from 'react-redux'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../../store/actions/system.actions'
import ModalCliente2 from '../../../Cadastros/Cliente/ModalCliente/ModalCliente2'
import ModalProdutoEan from '../../../Cadastros/Produto/ModalProdutoEan'
import './ImportacaoMultiploCicloEntrega.css'

function ImportacaoMultiploCicloEntrega({ history, dispatch }) {
  const { state, localDispatch } = useImportacaoMultiploCicloEntregas()

  const mCiclo = history.location.state.mCiclo

  useEffect(() => {
    localDispatch.getCiclosImportados(mCiclo)
  }, [])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  useEffect(() => {
    if (state.loadingMessage) {
      dispatch(showLoadingBox(state.loadingMessage, 'Aguarde . . .'))
    } else {
      dispatch(hideLoadingBox())
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.successMessage) {
      dispatch(showMessageBox(state.successMessage, null))
      localDispatch.resetState()
    }
  }, [state.successMessage])

  // Render
  return (
    <>
      <CustomPanel showBtnNovo={false} onVoltar={history.goBack}>
        <div className="p-grid">
          <div className="p-col-12">
            <ImportExcelFile
              label="Importar"
              classes="btnImportar"
              onFileImported={content => localDispatch.onFileImported(content, mCiclo.id)}
            />
          </div>
          <div className="p-col-12">
            <CustomTabView activeIndex={state.selectedTab} onTabChange={() => {}}>
              <TabPanel header={'Ciclos Importados'}>
                <CiclosDataTable
                  ciclos={state.ciclos}
                  onDataOperacaoChange={localDispatch.onDataOperacaoChange}
                  onSalvar={() => localDispatch.updateCicloEntregaDataOperacao(state.ciclos)}
                />
              </TabPanel>
              <TabPanel
                header={'Clientes Não Cadastrados'}
                disabled={state.clientesNaoCadastrados.length === 0}
              >
                <ClientesNaoCadastradosDataTable
                  clientes={state.clientesNaoCadastrados}
                  onClienteClick={cliente => localDispatch.openModalCliente(cliente)}
                />
              </TabPanel>
              <TabPanel
                header={'Produtos Não Cadastrados'}
                disabled={state.produtosNaoCadastrados.length === 0}
              >
                <ProdutosNaoCadastradosDataTable
                  produtos={state.produtosNaoCadastrados}
                  onProdutoClick={produto => localDispatch.openModalProduto(produto)}
                />
              </TabPanel>
              <TabPanel
                header={'Caixas Fracionadas'}
                disabled={state.rowsCaixaFracionadas.length === 0}
              >
                <CaixasFracionadasNaoCadastradosDataTable
                  rowsCaixasFracionadas={state.rowsCaixaFracionadas}
                />
              </TabPanel>
            </CustomTabView>
          </div>
        </div>
      </CustomPanel>
      <ModalCliente2
        onResponse={localDispatch.onModalClienteResponse}
        visible={state.showModalCliente}
        selectedCliente={state.selectedCliente}
        companyId={6}
      />
      <ModalProdutoEan
        visible={state.showModalProduto}
        onResponse={localDispatch.onModalProdutoResponse}
        selectedProduto={state.selectedProduto}
      />
    </>
  )
}

//-------------------------
// Local Components
//-------------------------

function CiclosDataTable({ ciclos, onDataOperacaoChange, onSalvar }) {
  return (
    <div className="p-grid" style={{ width: '100%' }}>
      <div className="p-col-3">
        <Btn onClick={onSalvar}>Salvar Data de Operação</Btn>
      </div>
      <div className="p-col-12">
        <DataTable value={ciclos} emptyMessage={'Nenhum Ciclo Importado'}>
          <Column field={'delivery_cycle_id'} header={'Código'} style={tableCellCentered(150)} />
          <Column field={'delivery_cycle_name'} header={'Ciclo de Entrega'} />

          <Column field={'tp_name'} header={'Operação Logística'} />
          <Column
            field={'qte_identificadores'}
            header={'Qte Identificadores'}
            style={tableCellCentered(150)}
          />
          <Column field={'qte_sku'} header={'Qte SKU'} style={tableCellCentered(100)} />
          <Column
            header={'Data de Operação'}
            style={tableCellCentered(150)}
            body={item => (
              <CustomCalendar
                value={item.data_operacao ? new Date(item.data_operacao) : null}
                onChange={value => onDataOperacaoChange(value, item)}
              />
            )}
            bodyStyle={tableCellCentered()}
            className="ImportacaoMultiploCicloCalendario"
          />
        </DataTable>
      </div>
    </div>
  )
}

function ClientesNaoCadastradosDataTable({ clientes, onClienteClick }) {
  return (
    <DataTable
      value={clientes}
      selectionMode={'single'}
      onSelectionChange={e => onClienteClick(e.value)}
    >
      <Column field={'code'} header={'Código'} style={tableCellCentered(150)} />
      <Column field={'fantasia'} header={'Fantasia'} />
    </DataTable>
  )
}

function ProdutosNaoCadastradosDataTable({ produtos, onProdutoClick }) {
  return (
    <DataTable
      value={produtos}
      selectionMode={'single'}
      onSelectionChange={e => onProdutoClick(e.value)}
      className="auto-layout"
    >
      <Column field={'code'} header={'Código'} style={tableCellCentered(200)} />
      <Column field={'name'} header={'Produto Não Cadastrado'} />
    </DataTable>
  )
}

function CaixasFracionadasNaoCadastradosDataTable({ rowsCaixasFracionadas }) {
  return (
    <DataTable value={rowsCaixasFracionadas}>
      <Column field={'clientCode'} header={'Cód. Cli.'} style={tableCellCentered(150)} />
      <Column field={'clientName'} header={'Cliente'} />
      <Column field={'identifier'} header={'Identificador'} style={tableCellCentered(150)} />
      <Column field={'productCode'} header={'Cód. Prod.'} style={tableCellCentered(150)} />
      <Column field={'productName'} header={'Produto'} />
      <Column field={'unity'} header={'CX/Un'} style={tableCellCentered(80)} />
      <Column field={'quantity'} header={'Quantidade'} style={tableCellCentered()} />
    </DataTable>
  )
}

export default connect()(withRouter(ImportacaoMultiploCicloEntrega))
